<template>
  <div>
    <div :class="overlay ? `homepage-hero-content-overlay-wrapper homepage-video-content-overlay-wrapper-${sectionId} ${!showOverlay ? 'overlay-hidden' : ''}` : ''">
      <div
        v-if="showOverlay && !hero && !autoplay"
        class="video--video__static-image"
      >
        <!-- Image filled using CSS background-image -->
      </div>

      <div
        v-if="showOverlay && !hero && !autoplay"
        class="video--video__text-block"
        v-on:click="play"
        v-on:keyup.enter="play"
      >
        <div class="homepage-video-play-button" tabindex="0">
          <div class="homepage-video-play-button-inner" />
        </div>
      </div>

      <div :class="{ 'embed-container': !hero, 'type-youtube' : videoType === 'youtube' && !hero }">
        <div ref="video" class="video">
          <video
            v-if="videoType === 'mp4'"
            ref="videoMP4"
            class="hero-video-mp4" playsinline controls
          >
            <source v-bind:src="url" type="video/mp4" />
          </video>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Youtube from '../global/Youtube';
import Vimeo from '../global/Vimeo';
import MP4Video from '../global/MP4Video';
import ThemeBase from '../ThemeBase';

export default Vue.extend({
  props: {
    theme: ThemeBase,
    hero: Boolean,
    videoType: {
      type: String,
      required: true,
      validator: function (value) {
        return ['youtube', 'vimeo', 'mp4'].indexOf(value) !== -1
      },
    },
    url: {
      type: String,
      required: true,
    },
    autoplay: {
      type: Boolean,
      required: true,
    },
    loop: Boolean,
    mute: Boolean,
    hideControls: {
      type: Boolean,
      default: false,
    },
    overlayOpacity: {
      type: Number,
      default: 1,
    },
    sectionId: {
      type: String,
      default: '',
    },
    overlay: Boolean,
  },
  data() {
    return {
      /** @type {import('../global/VideoBase').default} */
      player: null,
      isPlaying: false,
      showOverlay: true
    };
  },
  mounted() {
    if (this.videoType === 'youtube') {
      this.player = new Youtube(this.$root.theme, this.$refs.video);
    } else if (this.videoType === 'vimeo') {
      this.player = new Vimeo(this.$root.theme, this.$refs.video);
    } else if (this.videoType === 'mp4') {
      this.player = new MP4Video(this.$root.theme, this.$refs.videoMP4);
    }
    this.player.init({
      autoplay: this.autoplay,
      hideControls: this.hideControls,
      url: this.url,
      mute: this.mute,
      loop: this.loop,
      onPlay: this.onPlay,
      onPause: this.onPause,
      onEnd: this.onEnd,
    });
  },
  methods: {
    onPlay() {
      this.isPlaying = true;
    },
    onPause() {
      this.isPlaying = false;
    },
    onEnd() {
      this.isPlaying = false;
    },
    play() {
      this.player.play();
      this.showOverlay = false;
    }
  }
})
</script>
